import { Button } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import React, { useEffect, useState } from 'react';

import { DialogProps } from '../DialogProps';
import { TelerikReportViewer } from '@progress/telerik-react-report-viewer';
import { appSettings } from '../../../index';
import styles from './_report-viewer-dialog.module.scss';
import { Keyed } from '../../../Models/Keyed';
import { ReportInfo } from './ReportInfo';
import { useSelector } from 'react-redux';
import { AppState } from '../../../Store/rootReducer';
export interface ReportParameter {
  name: string;
  value: any;
}
export interface ReportViewerDialogProps extends DialogProps<ReportInfo> {
  reportName: string;
  parameters?: ReportParameter[];
  bearerToken: string;
  baseUrl: string;
}



export default function ReportViewerDialog(props: ReportViewerDialogProps) {
  const selectedClientId = useSelector((state: AppState) => state.performanceReport.selectedClientId);
  const serviceUrl = `${props.baseUrl}/reports`;
  const parameters: Keyed = {};
  props.parameters?.forEach(rp => {
    parameters[rp.name] = rp.value
  });

  // Defer rendering the TelerikReportViewer by one frame to avoid
  // StrictMode double-mount issues with jQuery-based viewer initialization.
  const [viewerReady, setViewerReady] = useState(false);
  useEffect(() => {
    const frameId = requestAnimationFrame(() => setViewerReady(true));
    return () => {
      cancelAnimationFrame(frameId);
      setViewerReady(false);
    };
  }, []);

  // Set up fetch interceptor when component mounts
  useEffect(() => {
    const originalFetch = window.fetch;
    
    window.fetch = function(...args) {
      let [url, options = {}] = args;
      
      if ((url as string)?.includes('/api/reports') === true) {
        options.headers = {
          ...options.headers,
          'X-Client-Id': selectedClientId ?? ''
        };
      }
      
      return originalFetch(url, options);
    };

    // Cleanup on unmount
    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  return (
    <div className={styles.reportViewerDialogContainer}>
      <DialogContent className={styles.callDialogContent}>
        <div className={styles.reportViewer}>
          {viewerReady && (
            <TelerikReportViewer
              serviceUrl={serviceUrl}
              authenticationToken={props.bearerToken}
              reportSource={{
                report: props.reportName,
                parameters: parameters,              
              }}
              viewerContainerStyle={{
                position: 'absolute',
                left: '0px',
                right: '0px',
                top: '0px',
                bottom: '0px',
                overflow: 'hidden',
                clear: 'both',
                fontFamily: 'ms sans serif'
              }}
              viewMode="INTERACTIVE"
              scaleMode="SPECIFIC"
              scale={1.0}
              enableSearch={false}
              enableAccessibility={false} />
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button style={{ 
            // fontWeight: 'normal', 
            position: 'absolute', 
            bottom: 30, 
            right: 10, 
            height: '30px', 
            width: '68px',
            color: 'black',
            backgroundColor: '#cbcbcb',
            // make it use proper case
            textTransform: 'capitalize'
          }} 
          autoFocus
          variant="contained"
          onClick={() => {
            props.closeDialog();
          }}
          color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </div>
  );
}
